import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

export const revealOnScroll = (trigger, start = 'center center', end = '+=20%') => {
	return ScrollTrigger.create({
		trigger: trigger,
		start: start,
		scrub: 2,
		end: () => end,
		animation: gsap.from(trigger, {
			opacity: 0,
		}),
	});
};

export const revealLettersOnScroll = (trigger, text, start = 'top center') => {
	const split = new SplitText(text, { type: 'chars, words', wordsClass: 'word' });

	ScrollTrigger.create({
		trigger: trigger,
		pin: true,
		start: start,
		scrub: 2,
		invalidateOnRefresh: true,
		animation: gsap.from((split.chars), {
			opacity: 0,
			rotate: (i) => -i * 0.1,
			y: (i) => -i * 0.1,
			skewY: -5,
			stagger: 0.2,
		})
	});
}

export const bgShapesParallax = (trigger, selector, speed = 0.01) => {
	return ScrollTrigger.create({
		trigger: trigger,
		start: 0,
		end: 'max',
		scrub: 2,
		invalidateOnRefresh: true,
		animation: gsap.from(selector, {
			y: () => {
				return 1 - speed * (ScrollTrigger.maxScroll(window));
			}
		}),
	});
}